/**
 * Settings Modal for VariationTwoImagesPlusTextTrivia
 * Migrated to use shared SettingsModal pattern
 * Before: 180 lines | After: ~48 lines
 */
import { FC } from 'react';

import { ImageData } from '../VariationOne';
import {
  SettingsModal as SharedSettingsModal,
  WATERMARK_SECTIONS,
  withWatermarkDefaults,
} from '../shared';

export const TEXT_POSITIONS = ['bottom', 'top'];
const DIVIDERS = ['none', 'white', 'black'];

interface Props {
  image: ImageData;
  imageIndex: number;
  type: 'left' | 'right';
  onClose: () => void;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
}

const SettingsModal: FC<Props> = ({ type, image, ...props }) => {
  const typeText = type === 'left' ? 'Left' : 'Right';

  return (
    <SharedSettingsModal
      {...props}
      image={withWatermarkDefaults(image)}
      title={`${typeText} Image Parameters`}
      sections={[
        ...WATERMARK_SECTIONS,
        {
          title: `${typeText} Text Position`,
          type: 'radio',
          stateKey: 'textPosition',
          options: TEXT_POSITIONS,
        },
        {
          title: `Other ${typeText} Text Parameters`,
          type: 'checkbox',
          stateKey: '',
          checkboxes: [
            { key: 'quotes', label: 'Quotes' },
            { key: 'brakes', label: 'Custom brakes' },
          ],
        },
        {
          title: 'Cover Divider',
          type: 'radio',
          stateKey: 'divider',
          options: DIVIDERS,
          show: type === 'left',
        },
      ]}
    />
  );
};

export default SettingsModal;
